import { render, staticRenderFns } from "./AvailabilityAlertForm.vue?vue&type=template&id=37d50990"
import script from "./AvailabilityAlertForm.vue?vue&type=script&lang=js"
export * from "./AvailabilityAlertForm.vue?vue&type=script&lang=js"
import style0 from "./AvailabilityAlertForm.vue?vue&type=style&index=0&id=37d50990&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Label: require('/app/components/Label.vue').default})
